<template>
	<article class="marketing-section rei-guide-content-section pt-300-md pt-500-lg pb-200 pb-300-md pb-500-lg">
		<span :id="section.slug" class="rei-offset-anchor"></span>
		<h1 class="heading-2">{{ section.heading }}</h1>
		<p class="line-height-125 delta mt-25-smo gamma-md ff-ivar-text font-weight-lighter mb-100">
			{{ section.subhead }}
		</p>

		<slot> </slot>

		<BaseCtaLink v-if="section.link" :link="section.link" classes="display-inline-block mt-100" icon="arrow" />
	</article>
</template>

<script setup lang="ts">
import { REIGuideSection } from 'types/layout';
interface Props {
	section: REIGuideSection;
}
defineProps<Props>();
</script>
